import AllRoutes from "./All-Routes/AllRoutes"




function App() {
  return (
    <div >
      <AllRoutes />
    </div>
  );
}

export default App;